/* eslint-disable no-undef */
import React, { useState, useEffect } from 'react';
import WaitlistSize from './WaitlistSize.jsx';
import WaitlistCountry from './WaitlistCountry.jsx';
import WaitlistTerms from './WaitlistTerms.jsx';

const WaitlistContent = (props) => {
  const [skus, setSkus] = useState([]);
  const [sizes, setSizes] = useState([]);
  const [email, setEmail] = useState('');
  const [sizeError, setSizeError] = useState(false);
  const [countryError, setCountryError] = useState(false);
  const [valid, setValid] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [emailError, setEmailError] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);

  const addSku = (e) => {
    const sku = e.target.dataset.sku;
    const size = e.target.innerText;
    setSkus((skus) => [...skus, sku]);
    setSizes((sizes) => [...sizes, size]);
    setSizeError(false);
  };

  const removeSku = (e) => {
    let skuArray = [...skus];
    let sizeArray = [...sizes];
    let index = skus.indexOf(e.target.dataset.sku);
    if (index !== -1) {
      skuArray.splice(index, 1);
      setSkus([...skuArray]);
      sizeArray.splice(index, 1);
      setSizes([...sizeArray]);
    }
  };

  const updateEmail = (e) => {
    setEmail(e.target.value);
  };

  const validateForm = () => {
    setErrorMessage('');
    let emailMsg = '';
    let sizeMsg = '';
    let disclaimerChecked = true;
    let errorMessages = [];

    const expression =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (skus.length === 0) {
      errorMessages.push('select a size');
      setSizeError(true);
    } else {
      setSizeError(false);
    }

    if (email === '') {
      errorMessages.push('enter your email address');
      setEmailError(true);
    } else if (expression.test(String(email).toLowerCase())) {
      setEmailError(false);
    } else {
      errorMessages.push('enter a valid email address');
      setEmailError(true);
    }

    if (props.isInternational) {
      disclaimerChecked = false;
      const marketingCheckbox = document.querySelector('input[name="waitlist_marketing"]');
      // const waitlistCheckbox = document.querySelector('input[name="waitlist_list_only"]');
      const countrySelector = document.querySelector('#WaitlistCountry').value;

      if (!marketingCheckbox.checked) {
        errorMessages.push('select checkbox to agree to waitlist');
      }

      if (!countrySelector) {
        errorMessages.push('select a country');
        setCountryError(true);
      } else {
        setCountryError(false);
      }
    }

    if (errorMessages.length > 0) {
      errorMessages = errorMessages.join(', ');
      setErrorMessage(`Oops! Please fix the following errors: ${errorMessages}`);
      setValid(false);
    } else {
      setValid(true);
    }
  };

  useEffect(() => {
    signupListrak();
  }, []);

  useEffect(() => {
    if (valid) {
      const marketingCheckbox = document.querySelector('input[name="waitlist_marketing"]');
      const domain = window.location.host;
      const url =
        domain === 'www.windsorstore.com'
          ? 'https://shopify-inventory-service.wndsr.io/waitlist'
          : 'https://shopify-inventory-service.wndsr.dev/waitlist';

      const data = {
        contact: email,
        contact_type: 'email',
        skus: skus,
      };

      // eslint-disable-next-line promise/catch-or-return
      // eslint-disable-next-line no-undef
      // eslint-disable-next-line promise/catch-or-return
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
        body: JSON.stringify(data),
      })
        .then((res) => res.text())
        .then((data) => {
          document.getElementById('WaitlistEmailSubmit').click();
          setShowConfirmation(true);
          window.dataLayer.push({
            event: 'add_to_waitlist_submit',
            product_name: props.product.title,
            product_id: props.product.id,
          });
          console.log('add_to_waitlist_submit', props.product.title, props.product.id);
          return JSON.stringify(data);
        })
        .catch(() => {
          console.log('Error in sending request over to waitlist.');
        });
    }
  }, [valid]);

  const signupListrak = () => {
    (function () {
      if (typeof _ltk == 'object') {
        ltkCode();
      } else {
        (function (d) {
          if (document.addEventListener) document.addEventListener('ltkAsyncListener', d);
          else {
            e = document.documentElement;
            e.ltkAsyncProperty = 0;
            e.attachEvent('onpropertychange', function (e) {
              if (e.propertyName == 'ltkAsyncProperty') {
                d();
              }
            });
          }
        })(function () {
          ltkCode();
        });
      }
      function ltkCode() {
        _ltk_util.ready(function () {
          _ltk.Signup.New('Waitlist', 'WaitlistEmail', _ltk.Signup.TYPE.CLICK, 'WaitlistEmailSubmit', 'email');
          _ltk.Signup.SetField('Waitlist', 'WaitlistCountry');
          _ltk.Signup.SetField('Waitlist', 'WaitlistSource');
          _ltk.Signup.SetField('Waitlist', 'ltkSource');
        });
      }
    })();
  };

  const submitForm = (e) => {
    e.preventDefault();
    validateForm();
  };

  let productImage = '';
  let swatchUrl = '';

  props.product.variants.find((variant) => {
    if (variant.option1 === props.color) {
      const featuredImage = variant.featured_image ? variant.featured_image.src : props.product.featured_image;
      let ext = featuredImage.includes('.webp') ? '.webp' : '.jpg';
      const featuredImageSplit = featuredImage.split(ext);
      featuredImageSplit[0] += '_500x750_crop_center';
      productImage = featuredImageSplit.join(ext);
      swatchUrl = `https://cdn.shopify.com/s/files/1/0070/8853/7651/t/8/assets/${variant.barcode}_SWT_48x48_crop_center.jpg?v=${window.theme.swatches_updated_at}`;
      return true;
    } else {
      return false;
    }
  });

  return (
    <div className={`${showConfirmation ? 'WaitlistModal__confirmation' : ''} WaitlistModal__outer`}>
      {!showConfirmation && (
        <div>
          <form id="WaitlistForm" className="WaitlistModal__form" onSubmit={submitForm}>
            <div className="WaitlistModal__close" onClick={props.close}>
              <span className="WaitlistModal__close-icon"></span>
              <span className="WaitlistModal__close-icon"></span>
            </div>
            <h1 className="WaitlistModal__title">Join the Waitlist</h1>
            <p className="WaitlistModal__description">
              Select your size below and we'll email you when it becomes available!
            </p>
            <div className="WaitlistModal__details">
              <div className="WaitlistModal__details-half">
                <div className="WaitlistModal__image-container">
                  <img className="WaitlistModal__variant-image" src={productImage} />
                </div>
                <div className="WaitlistModal__variant-info">
                  <h2 className="WaitlistModal__variant-title">{props.product.title}</h2>
                  <span className="WaitlistModal__variant-color--label">Color </span>
                  <span className="WaitlistModal__variant-color">{props.color}</span>
                  <span
                    className="WaitlistModal__variant-swatch"
                    style={{
                      backgroundImage: 'url(' + swatchUrl + ')',
                    }}
                  ></span>
                </div>
              </div>
              <div className="WaitlistModal__details-half">
                <div className={`WaitlistModal__text--secondary ${sizeError ? 'WaitlistModal__size-error--text' : ''}`}>
                  Select Your Size
                </div>
                <div className="WaitlistModal__size-container">
                  {props.product.variants.map((variant) => {
                    if (window.inventory980) {
                      if (
                        variant.option1 === props.color &&
                        !window.inventory980.color[variant.id] &&
                        variant.option2 !== 'NS'
                      ) {
                        return (
                          <WaitlistSize
                            key={variant.id}
                            sku={variant.sku}
                            size={variant.option2}
                            sizeError={sizeError}
                            addSku={addSku}
                            removeSku={removeSku}
                          />
                        );
                      }
                    } else if (variant.option1 === props.color && !variant.available && variant.option2 !== 'NS') {
                      return (
                        <WaitlistSize
                          key={variant.id}
                          sku={variant.sku}
                          size={variant.option2}
                          sizeError={sizeError}
                          addSku={addSku}
                          removeSku={removeSku}
                        />
                      );
                    }
                  })}
                </div>
                <div className="WaitlistModal__email">
                  <input
                    id="WaitlistEmail"
                    className={`WaitlistModal__email-input ${emailError ? 'WaitlistModal__email-error' : ''}`}
                    type="email"
                    name="email"
                    placeholder="name@company.com"
                    onChange={updateEmail}
                  />
                </div>
                <input id="WaitlistSource" type="hidden" value="Waitlist" />
                <WaitlistCountry countryError={countryError} isInternational={props.isInternational} />
                <WaitlistTerms isInternational={props.isInternational} terms={props.disclaimer} />
              </div>
            </div>
            <p className="WaitlistModal__error-message">{errorMessage}</p>
            <button
              id="WaitlistEmailSubmit"
              type="submit"
              style={{
                display: 'none',
              }}
            ></button>
            <button
              id="WaitlistSubmit"
              data-product-name={props.product.title}
              data-product-id={props.product.id}
              type="submit"
              name="waitlist"
              className="WaitlistModal__button-submit Button Button--primary"
            >
              Join the Waitlist
            </button>
          </form>
        </div>
      )}

      {showConfirmation && (
        <div>
          <div className="WaitlistModal__close" onClick={props.close}>
            <span className="WaitlistModal__close-icon"></span>
            <span className="WaitlistModal__close-icon"></span>
          </div>
          <h1 className="WaitlistModal__title">You&apos;re On the List!</h1>
          <p className="WaitlistModal__description">
            We&apos;ll notify you at {email} when this product becomes available again.
          </p>
          <div className="WaitlistModal__details">
            <div className="WaitlistModal__details-half">
              <img className="WaitlistModal__variant-image" src={productImage} />
            </div>
            <div className="WaitlistModal__details-half">
              <h2 className="WaitlistModal__variant-title">{props.product.title}</h2>
              <div className="WaitlistModal__variant-row">
                <span className="WaitlistModal__variant-color--label">Color </span>
                <span className="WaitlistModal__variant-color">{props.color}</span>
              </div>
              <div className="WaitlistModal__variant-row">
                <span className="WaitlistModal__variant-color--label">size</span>
                {sizes.map((size, index) => {
                  return (
                    <span key={index}>
                      <span>{size}</span>
                      <span>{index < sizes.length - 1 ? ', ' : ''}</span>
                    </span>
                  );
                })}
              </div>
            </div>
          </div>

          <button
            onClick={props.close}
            type="submit"
            name="shop"
            className="WaitlistModal__button-submit Button Button--primary"
          >
            Continue Shopping
          </button>
        </div>
      )}
    </div>
  );
};

export default WaitlistContent;
